import styles from './style.styl'
import reddot from '../../assets/images/ribbons/reddot.png'
import economist from '../../assets/images/ribbons/the-economist.png'

export const Ribbons = () => {
  return <div className={styles.ribbons}>
    <div className={styles.ribbon}>
      <img src={reddot} alt='reddot' />
    </div>
    <div className={styles.ribbon}>
      <img src={economist} alt='the economist' />
    </div>
  </div>
}



// WEBPACK FOOTER //
// ./components/ribbons/index.js